<template>
  <div>
    <h1>Nutzerübersicht</h1>
    <div>
      Nur Nutzer zeigen, die aktiv sind oder nach dem {{minimumLeaveDate.format("DD.MM.yyyy")}} gekündigt haben <input type="checkbox" v-model="showActiveUsers" autocomplete="off" />
    </div>
    <div v-if="users.length > 0">
      <table class="table">
        <tr>
          <td>Name</td>
          <td>Email</td>
          <td>Stunden KW {{date.format("W")}}</td>
          <td>Stunden {{date.format("MMMM")}}</td>
          <td>Stunden {{dateYearStart.format("DD.MM.yyyy")}}-{{dateRangeEnd.format("DD.MM.yyyy")}}</td>
          <td>Stunden/Woche</td>
          <td>Regeln</td>
          <template v-if="adminAccess">
            <td>Urlaub</td>
          </template>
          <td><router-link to="/users/userDetails" tag="button" class="btn btn-info">Erstellen</router-link></td>
          <td></td>
        </tr>
        <tr v-for="user in users" :key="user.id" v-if="!showActiveUsers || (!user.leaveDate || user.leaveDate < minimumLeaveDate)">
          <td><router-link :to="{ path: '/users/userHoursDateRange', query: { userId: user.id }}" class="btn btn-info">{{user.name}}</router-link></td>
          <td>{{user.email}}</td>
          <td><router-link :to="{ path: '/users/userHoursDateRange', query: { from: dateWeekStart.format('yyyy-MM-DD'), to: dateWeekEnd.format('yyyy-MM-DD'), userId: user.id }}" class="btn btn-info"><userRequiredHours :user="user" :from="dateWeekStart" :to="dateWeekEnd" :showSum="false" :key="user.id" @illness="deductIllness(user)" /></router-link></td>
          <td><router-link :to="{ path: '/users/userHoursDateRange', query: { from: dateMonthStart.format('yyyy-MM-DD'), to: dateMonthEnd.format('yyyy-MM-DD'), userId: user.id }}" class="btn btn-info"><userRequiredHours :user="user" :from="dateMonthStart" :to="dateMonthEnd" :showSum="false" :key="user.id" /></router-link></td>
          <td>
            <router-link class="btn btn-outline-info" :to="{ path: 'hourdetails', query: { userId: user.id }}"><userRequiredHours :user="user" :from="dateYearStart" :to="dateRangeEnd" :showSum="true" :showCarryOverFromPreviousYear="true" /></router-link>
          </td>
          <td>{{user.workingHoursPerWeek | hour}}{{differentHoursDisplay(user)}}
            <span v-if="user.differentHoursCount != 0">+ [{{ user.differentHoursCount }}]</span>
          </td>
          <td><userRuleApplication :user="user" /></td>
          <template v-if="adminAccess">
            <td>
                <router-link class="btn" :to="{ path: 'leaveDetails', query: { userId: user.id }}"><UserLeaves :user="user"/></router-link>
            </td>
          </template> 
          <td>
            <router-link class="btn btn-outline-info" :to="{ path: 'userDetails', query: { userId: user.id }}">Bearbeiten</router-link>
          </td>
        </tr>
      </table>
      <div>
      </div>
    </div>
    <div v-else>
      Keine Nutzer gefunden.
    </div>
  </div>
</template>

<style>
  .home {
    display: flex;
    align-items: center;
    flex-direction: column;
  }
</style>

<script>
  import { mapGetters, mapState } from "vuex";
  import axios from "axios";
  import moment from "moment";
  import UserRuleApplication from "./userRuleApplication";
  import UserRequiredHours from "./userRequiredHours";
  import UserLeaves from "./userLeaves.vue";


  export default {
    components: {
      UserRuleApplication,
      UserRequiredHours,
      UserLeaves
    },
    name: "users",
    data() {
      var date = moment();
      var startOfWeek = moment().startOf("isoweek");
      var endOfWeek = moment().endOf("isoweek");
      var startOfMonth = moment().startOf("month");
      var endOfMonth = moment().endOf("month");
      var startOfYear = moment().year(2017).startOf("year");
      var endOfRange = moment(); // This will be set to the current date and time

      return {
        users: [],
        holidays: [],
        date: date,
        dateWeekStart: startOfWeek,
        dateWeekEnd: endOfWeek,
        dateMonthStart: startOfMonth,
        dateMonthEnd: endOfMonth,
        dateYearStart: startOfYear,
        dateRangeEnd: endOfRange,
        showActiveUsers: true,
        minimumLeaveDate: moment().subtract(30, 'd'),
        currentMonth: moment().month() + 1,
        moment: moment,
        differentHoursData: [],
      };
    },
    methods: {
      totalWorkingHoursPerWeek: function(user) {
        const {workingHoursPerWeek, differentHoursCount} = user;
        return (workingHoursPerWeek + differentHoursCount);
      },
      
      // calculate and deduct illness hours from current month's workable hours
      deductIllness(user) {
        const { illnesses } = user;
        const currentDate = moment();
        const hoursPerDay = this.calculateHoursPerDay(this.totalWorkingHoursPerWeek(user));
        let monthlyIllnessDayCounter = 0;
        if (illnesses != null) {
          illnesses.forEach(e => {
            let fromDate = moment(e.from)
            let toDate = moment(e.to)
            // filter only current month illness
            if (fromDate.isSame(currentDate, 'month')) {
              // calculate only same month illnesses
              if (fromDate.isSame(toDate, 'month')) {
                let dateDiff = parseInt(toDate.diff(fromDate, 'days'))
                if (dateDiff == 0 || dateDiff > 0) {
                  monthlyIllnessDayCounter += 1
                }
              } 
            } 
          })
        }
        return hoursPerDay*monthlyIllnessDayCounter
      },
      
      // calculates the Hours per day each employee has to work
      calculateHoursPerDay: function (totalWorkingHoursPerWeek) {
        return (totalWorkingHoursPerWeek/5)
      },

      differentHoursDisplay(user) {
        if (user) {
          axios({ method: "GET", url: process.env.VUE_APP_API_PATH+"DifferentHours/GetHoursByUser/" + user.id }).then(result => {
            user.differentHoursCount = result.data
          }, error => {
            console.error(error);
            if (error.response.status == 401) {
              this.$router.push("/");
            }
          });
        }
      }
    },
    computed: {
      ...mapGetters(["isAuthenticated", "authStatus", "getProfile"]),
      ...mapState({
        adminAccess: state => state.user.profile.adminAccess,
      }),
    },
    mounted() {
      //Load users
      axios({ method: "GET", url: process.env.VUE_APP_API_PATH+"user/get" }).then(result => {
        this.users = result.data;
      }, error => {
        console.error(error);
        if (error.response.status == 401) {
          this.$router.push("/");
        }
      });
      //Load Holidays
      axios({ method: "GET", url: process.env.VUE_APP_API_PATH+"Holidays" }).then(result => {
        this.holidays = result.data;
      }, error => {
        console.error(error); 
        if (error.response.status == 401) {
          this.$router.push("/");
        }
      });
    },
  };


</script>
